import { EVENTS } from "@/constants/socket";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback, useEffect } from "react";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { useSocket } from "@/providers/SocketProvider";
import { useCheckUnread } from "@/api/services/main/information";
import { NOTIFICATION_TYPE } from "@/features/dashboard/constants/notificationTab";

export const useUnreadNotification = () => {
  const queryClient = useQueryClient();
  const { data: checkResult } = useCheckUnread({ types: Object.values(NOTIFICATION_TYPE) });

  const { socket } = useSocket();

  const handleNewNotification = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.INFORMATION.CHECK_UNREAD] });
    queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.INFORMATION.FETCH_LIST] });
  }, [queryClient]);

  useEffect(() => {
    if (!socket) return;

    socket.on(EVENTS.INFORMATION.NEW_INFORMATION, handleNewNotification);
    socket.on(EVENTS.INFORMATION.DRAFT_INFORMATION, handleNewNotification);
    socket.on(EVENTS.INFORMATION.DELETE_INFORMATION, handleNewNotification);

    return () => {
      socket.off(EVENTS.INFORMATION.NEW_INFORMATION, handleNewNotification);
      socket.off(EVENTS.INFORMATION.DRAFT_INFORMATION, handleNewNotification);
      socket.off(EVENTS.INFORMATION.DELETE_INFORMATION, handleNewNotification);
    };
  }, [socket, handleNewNotification]);

  return checkResult;
};
